{% block swag_cms_extensions_sidebar_page_scroll_behavior_config %}
    <div class="swag-cms-page-config__scroll-navigation-page-settings">

        {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling %}
            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_description %}
                <div class="info-text">
                    {{ $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.description') }}
                </div>
            {% endblock %}

            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_native_scrolling %}
                <mt-switch
                    v-model="scrollNavigationPageSettings.nativeScrolling"
                    class="scroll-navigation__native-scrolling"
                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.nativeScrollingLabel')"
                    :helpText="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.nativeScrollingHelpText')"
                    :disabled="scrollNavigationPageSettings.active || !acl.can('cms.editor')"
                />
            {% endblock %}

            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_active %}
                <mt-switch
                    v-model="scrollNavigationPageSettings.active"
                    class="scroll-navigation__smooth-scrolling-active"
                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.activeLabel')"
                    :helpText="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.activeHelpText')"
                    :disabled="!pageHasNavigationPoints || !acl.can('cms.editor')"
                />
            {% endblock %}

            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_easing %}
                <sw-single-select
                    v-model:value="scrollNavigationPageSettings.easing"
                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.easingLabel')"
                    :options="easingTypes"
                    :disabled="!smoothScrollingActive  || !acl.can('cms.editor')"
                ></sw-single-select>
            {% endblock %}

            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_duration %}
                <mt-number-field
                    v-model="scrollNavigationPageSettings.duration"
                    class="scroll-navigation__smooth-scrolling-duration"
                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.durationLabel')"
                    :disabled="!smoothScrollingActive || !acl.can('cms.editor')"
                    :digits="0"
                >
                    {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_duration_suffix %}
                        <template #suffix>
                            <span class="scroll-navigation__smooth-scrolling-duration-suffix">
                                {{ $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.durationSuffix') }}
                            </span>
                        </template>
                    {% endblock %}
                </mt-number-field>
            {% endblock %}

            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_advanced %}
                <sw-sidebar-collapse
                    class="scroll-navigation__smooth-scrolling-advanced-settings"
                    :expandOnLoading="false"
                >
                    {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_advanced_header %}
                        <template #header>
                            {{ $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.advancedSettingsLabel') }}
                        </template>
                    {% endblock %}

                    {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_advanced_content %}
                        <template #content>

                            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_bouncy %}
                                <mt-switch
                                    v-model="scrollNavigationPageSettings.bouncy"
                                    class="scroll-navigation__smooth-scrolling-bouncy"
                                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.bouncyLabel')"
                                    :disabled="!smoothScrollingActive || scrollNavigationPageSettings.easing === 'linear' || !acl.can('cms.editor')"
                                />
                            {% endblock %}

                            {% block swag_cms_extensions_sidebar_page_scroll_behavior_config_smooth_scrolling_easing_degree %}
                                {# ToDo CMS-11 - Re-enable helptext and remove tooltip #}
                                <mt-number-field
                                    v-model="scrollNavigationPageSettings.easingDegree"
                                    class="scroll-navigation__smooth-scrolling-easing-degree"
                                    :label="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.easingDegreeLabel')"
                                    :disabled="easingDegreeDisabled  || !acl.can('cms.editor')"
                                    {#                                    :helpText="$tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.easingDegreeHelpText')"#}
                                    v-tooltip="{
                                        message: $tc('swag-cms-extensions.sw-cms.detail.scrollNavigation.pageSettings.easingDegreeHelpText')
                                    }"
                                    :digits="0"
                                    :min="2"
                                    :max="32"
                                ></mt-number-field>
                            {% endblock %}
                        </template>
                    {% endblock %}
                </sw-sidebar-collapse>
            {% endblock %}
        {% endblock %}
    </div>
{% endblock %}
